<template>
  <div v-if="campaignItem" class="content-details-section">
    <!-- campaign content -->
    <div v-if="!isMessage && campaignItem.is_sms_campaign" class="data-title">campaign content</div>

    <div v-if="campaignItem.is_sms_campaign && campaignItem.template_image" class="messages-content-section content-wrapper">
      <label>mms notification image</label>
      <div class="notification-image media-row">
        <img
          class="big-thumbnail"
          @click="setPreviewModal('notificationImage')"
          :src="campaignItem.template_image.attachment.thumb">
      </div>
    </div>

    <div v-if="campaignItem.is_sms_campaign && campaignItem.classic_campaign && campaignItem.audio.length" class="messages-content-section content-wrapper">
      <label>voice text</label>
      <div class="audio-sent-section">
        <media-playback
          v-for="audio in campaignItem.audio"
          :key="audio"
          :attachedMedia="{ url: audio }"
          :mediaPlayerOptions="mediaPlayerOptions"
        />
      </div>
    </div>

    <div v-if="(campaignItem.is_sms_campaign || isMessage) && campaignItem.template_content" class="messages-content-section content-wrapper">
      <label v-if="!isMessage">sms notification message</label>
      <div class="callout message complete-sms-content">
        <div v-if="campaignItem.classic_campaign">{{campaignItem.classic_sms_content}}</div>
        <div v-if="!campaignItem.classic_campaign">{{this.isReferral ? campaignItem.referral_template_content : campaignItem.template_content}}</div>
      </div>
    </div>

    <!-- sms/stashboard content -->
    <template v-if="(campaignItem.is_sms_campaign && !campaignItem.classic_campaign) || isMessage">
      <div class="data-title">text content</div>

      <div class="messages-content-section stashboard">

        <div v-if="smsStashboardMedia && smsStashboardMedia.length" class="stashboard-content-section content-wrapper">
          <label>stashboard media</label>

          <div class="stashboard-media-section media-row">
            <template v-for="(item, index) in smsStashboardMedia">
              <a v-if="item.media_type && item.media_type == 'video' && !item.result_url.includes('youtube')"
                :class="index == 0 ? 'big-thumbnail':'small-thumbnail'"
                @click="setPreviewModal('smsStashboardMedia', index)"
                :key="item.id"
              >
                <fai :icon="['far', 'circle-play']" />
              </a>
              <img v-else
                :class="index == 0 ? 'big-thumbnail':'small-thumbnail'"
                @click="setPreviewModal('smsStashboardMedia', index)"
                :key="item.id"
                :src="item.result_url.includes('youtube') ? youtubeImgUrl(item.result_url) : item.result_url"
              >
            </template>
          </div>
        </div>

         <div v-if="campaignItem.mms.length && isMessage && !campaignItem.has_ad && !(smsStashboardMedia && smsStashboardMedia.length)">
          <label>stashboard media</label>

          <div class="stashboard-media-section media-row">
            <img
              class="big-thumbnail"
              @click="setPreviewModal('classicMmsImage')"
              :src="campaignItem.mms[0]"
            >
          </div>
        </div>

        <div v-if="campaignItem.has_ad" class="stashboard-content-section content-wrapper">
          <label>sponsored image</label>
          <div class="ad-media-section media-row">
            <img
              v-if="campaignItem.has_watermarked_image"
              class="big-thumbnail"
              @click="setPreviewModal('adImage')"
              :src="campaignItem.ad_image"
            >
            <div v-else>--processing--</div>
          </div>
        </div>

        <div v-if="campaignItem.sms_content" class="sms-content-section content-wrapper">
          <label>stashboard message</label>
          <div class="callout message stashboard-text-content">
            <div>{{campaignItem.sms_content}}</div>
          </div>
        </div>

      </div>
    </template>

    <!-- push/notification content -->
    <template v-if="campaignItem.is_push_campaign && !campaignItem.classic_campaign">
      <div class="data-title">native app content</div>
      <div class="messages-content-section stashboard">

        <div v-if="pushStashboardMedia && pushStashboardMedia.length" class="push-media-content-section content-wrapper">
          <label>native app media</label>
          <div class="push-media-section media-row">
            <template v-for="(item, index) in pushStashboardMedia">
              <a v-if="item.media_type && item.media_type == 'video' && !item.result_url.includes('youtube')"
                :class="index == 0 ? 'big-thumbnail':'small-thumbnail'"
                @click="setPreviewModal('pushStashboardMedia', index)"
                :key="item.id"
              >
                <fai :icon="['far', 'circle-play']" />
              </a>
              <img v-else
                :class="index == 0 ? 'big-thumbnail':'small-thumbnail'"
                @click="setPreviewModal('pushStashboardMedia', index)"
                :key="item.id"
                :src="item.result_url.includes('youtube') ? youtubeImgUrl(item.result_url) : item.result_url"
              >
            </template>
          </div>
        </div>

        <div v-if="campaignItem.has_ad" class="push-notification-content-section content-wrapper">
          <label>sponsored image</label>
          <div class="ad-media-section media-row">
            <img
              v-if="campaignItem.has_watermarked_image"
              class="big-thumbnail"
              @click="setPreviewModal('adImage')"
              :src="campaignItem.ad_image"
            >
            <div v-else>--processing--</div>
          </div>
        </div>

        <div v-if="campaignItem.push_notification_content" class="push-notification-content-section content-wrapper">
          <label>push notification message</label>
          <div class="callout message push-notification-content">
            <div>{{campaignItem.push_notification_content}}</div>
          </div>
        </div>

        <div v-if="campaignItem.push_content" class="push-stashboard-content-section content-wrapper">
          <label>native app message</label>
          <div class="callout message push-text-content">
            <div>{{campaignItem.push_content}}</div>
          </div>
        </div>

      </div>
    </template>

    <!-- email content -->
    <template v-if="campaignItem.is_email_campaign">
      <div class="data-title">email content</div>
      <div class="email-content-section content-wrapper">
        <label>email subject</label>
        <div class="callout message email-subject">
          <div>{{campaignItem.email_subject}}</div>
        </div>

        <label>email message</label>
        <img
          :src="campaignItem.email_preview_image"
          class="email-image-preview cursor-pointer"
          @click="setPreviewModal('emailPreviewImage')"
          alt="email preview"
        />
      </div>
    </template>

    <!-- Image Modal -->
    <media-preview-modal
      v-if="showModal"
      :mediaUrl="modalMediaUrl"
      :mediaType="modalMediaType"
      :indexInfo="indexInfo"
      @changeIndex="selectedIndex = selectedIndex + $event"
      @rejected="showModal = null"
    >
    </media-preview-modal>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import MediaPlayback from '../MediaAttachments/MediaPlayback'
  import MediaPreviewModal from '../shared/MediaPreviewModal'

  export default {
    props: {
      campaignItem: Object,
      isMessage: Boolean,
      isTracked: Boolean,
      isReferral: Boolean,
    },

    name: 'ContentSection',

    components: {
      MediaPlayback,
      MediaPreviewModal
    },

    data() {
      return {
        expandMMS: true,
        groupsWithSelected: null,
        mediaPlayerOptions: {
          barRadius: 4,
          barWidth: 10,
        },
        merchantSegmentIds: null,
        modalConfig: {},
        pushStashboardMedia: [],
        selectedGroups: null,
        selectedIndex: null,
        smsStashboardMedia: [],
        showModal: null
      }
    },

    created() {
      if(this.campaignItem?.stashboard_media) {
        this.smsStashboardMedia = this.campaignItem.stashboard_media.filter(item => ['mms', 'universal'].includes(item.communication_type) && !item.ad_id)
        this.pushStashboardMedia = this.campaignItem.stashboard_media.filter(item => ['push', 'universal'].includes(item.communication_type) && !item.ad_id)
      }
    },

    methods: {
      setPreviewModal(modalTypeShow, index = 0) {
        this.selectedIndex = index;
        this.showModal = modalTypeShow;
      },

      youtubeImgUrl(url, type) {
        // assuming the www.youtube.com/embed/videoID style link
        const videoID = url.split("/").slice(-1)[0].split("&")[0]
        return `https://img.youtube.com/vi/${videoID}/0.jpg`
      }
    },

    computed: {
      haveClassicCampaignDisabledOrIsAutoConnectAndNotificationMmsEnabled(){
        return (!this.classicCampaignsEnabled || this.isMessage) && this.hasNotificationMmsMetaEnabled
      },

      modalMediaUrl() {
        switch (this.showModal) {
          case "notificationImage":
            return this.campaignItem.template_image.attachment.url;
          case "classicMmsImage":
            return this.campaignItem.mms[0];
          case "adImage":
            return this.campaignItem.ad_image;
          case "emailPreviewImage":
            return this.campaignItem.email_preview_image;
          case "smsStashboardMedia":
          case "pushStashboardMedia":
            return this[this.showModal][this.selectedIndex].result_url;
          default:
            return null
        }
      },

      modalMediaType() {
        if (this.showModal && this.showModal.includes("StashboardMedia")) {
          const mediaObj = this[this.showModal][this.selectedIndex]

          if (mediaObj.result_url.includes("youtube")) {
            return "youtube"
          } else {
            return mediaObj.media_type || "image"
          }
        } else {
          return "image"
        }
      },

      indexInfo() {
        // [current index, last index]
        if (this.showModal && this.showModal.includes("StashboardMedia")) {
          return [this.selectedIndex, this[this.showModal].length - 1]
        } else {
          return [0, 0]
        }
      },

      ...mapGetters([
        'classicCampaignsEnabled',
        'hasNotificationMmsMetaEnabled',
      ]),

      ...mapState([
        'currentMerchant'
      ])
    }
  }
</script>

<style scoped>
.email-image-preview {
  height: auto;
  width: 200px;
  margin-bottom: 16px;
}

.content-details-section >>> .content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: start;
}

.content-wrapper >>> .callout.message {
  background: #016fb9;
  border: none;
  color: white;
  word-wrap: break-word;
  width: 100%
}

.content-wrapper >>> .media-row {
  display: flex;
  align-items: end;
  overflow: auto hidden;
  width: 100%;
}

.media-row > .small-thumbnail {
  border-radius: 8px;
  height: 93px;
  max-width: 93px;
  border: 1px solid #128ff9;
  cursor: pointer;
}

.media-row > .big-thumbnail {
  border-radius: 8px;
  height: 125px;
  max-width: 125px;
  border: 1px solid #128ff9;
  cursor: pointer;
}

.small-thumbnail >>> .svg-inline--fa {
  height: 93px;
  width: 93px;
}

.big-thumbnail >>> .svg-inline--fa {
  height: 125px;
  width: 125px;
}

.content-details-section >>> .simple-modal > div {
  max-width: 850px;
}

.content-details-section >>> .simple-modal footer {
  display: none;
}

.content-details-section >>> .simple-modal >>> .yt-media {
  width: 600px;
}
</style>
